import baseService from '../services/BaseService';

export const getRequest = (callback, api = {}, gridKey, errorCallback) => dispatch => {
	const { key, method = 'get', ...rest } = api;
	return baseService
		[method](key, rest)
		.then((response) => (callback(response, gridKey)))
		.catch((error) => {
			errorCallback && errorCallback(error);
			console.error(error);
		});
};